module.exports = __webpack_public_path__ + "img/2.aa431674.svg";